 /*                              @Author : {}
* Copyright (c) 2021, by Tush Entertainment
* Permission to use, copy, modify or distribute this software in binary or source form
* for any purpose is allowed only under explicit prior consent in writing from Tush Entertainment.
* THE SOFTWARE IS PROVIDED "AS IS" AND TUSH ENTERTAINMENT DISCLAIMS
* ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED
* WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL TUSH ENTERTAINMENT
* BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL
* DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR
* PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS
* ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS
* SOFTWARE.THIS SOFTWARE IS PROTECTED BY COPYRIGHT LAWS FROM INDIA AND USA.
* ANY OR ALL PART OF THIS SOFTWARE OR SOURCES CANNOT BE USED FOR ANY TYPES OF
* PRODUCTS WHICH IS DIRECTLY AND INDIRECTLY AFFECTING THE LIFE OF HUMANS.
*/

import React,{useEffect, useState} from 'react';
import '../css/App.css';
import '../css/Home.css';
import LineChart from './Graphs/LineChart';
import Incomechart from './Graphs/Incomechart';
import Userschart from './Graphs/Userschart';
import Downloadschart from './Graphs/Downloadschart';
import sampler from '../Objects/axiosjson';
import Spin from './Spinner/Spin';
import { valHooks } from 'jquery';
const Dashboard = ({icon}) => {
  //setting role and email of user in localstorage
  const name = localStorage.getItem('role');
  const email = localStorage.getItem('email');
  const [data,setData]=useState({})
  const [loading,setloading]=useState(true)
  const APP_TYPE_VOOVI = "normal";
  const APP_TYPE_MOOVI = "moovi";
  const [app_type, setAppType] = useState(APP_TYPE_VOOVI);
  var controller;
  useEffect(()=>{
    const exec = () => {
      controller = new AbortController();
      sampler.get('/dashboard?app_type='+app_type,{ signal: controller.signal})
      .then(res => {
        setData(res.data.data);
        setloading(false)
      }).catch(error => {
        console.error('Error fetching data:', error);
        if (error.name === 'CanceledError') {
            console.log('Successfully aborted the request');
        }
      });
    };
    exec()
  },[app_type])

    const  loadData = (app_type) => {
      //aboting previous request if any
      if(controller)controller.abort();
      controller = undefined;
      setloading(true);
      setAppType(app_type);
    }

    return (
      <>
      {/* {!loading ? '':<Spin/>} */}
        <div className="subcr content">
          <span className="head">
            <span className="dashhead m-2">
                <i className="fa fa-bars" onClick={icon}></i>
                <h4>Dashboard</h4>
            </span>
            <span className="userhead">
             <p style={{'fontWeight':'500'}}><i className="fa fa-envelope"></i> {email} <br/>
             <i className="fa fa-user"></i> Role - {name}</p>
            </span>
          </span>

           <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
              <button class="nav-link active" id="normal" data-bs-toggle="tab"  type="button" role="tab" aria-controls="{app_type}" aria-selected="true" onClick={() => loadData(APP_TYPE_VOOVI)}>Voovi</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="moovi" data-bs-toggle="tab"  type="button" role="tab" aria-controls="{app_type}" aria-selected="false" onClick={() => loadData(APP_TYPE_MOOVI)}>Moovi</button>
            </li>
          </ul>


         <div class="tab-content" id="myTabContent">
           <div class="tab-pane fade show active"  role="tabpanel" aria-labelledby="{app_type}">
            <div className='container-fluid'>
            <div className='row'>
              <div className='col-md-6 pt-2'>
                <LineChart subscriptionData={data.subscription} loading={loading}/>
                </div>
              <div className='col-md-6 pt-2'>
                <Incomechart incomeData={data.income} loading={loading}/>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-6 pt-2'>
                <Userschart registerUserData={data.registeredUser} loading={loading}/>
              </div>
              <div className='col-md-6 pt-2'>
                <Downloadschart loading={loading}/>
              </div>
            </div>
           </div>
           </div>
         </div>
          <p className='small' style={{'marginLeft':'18px','color':'#aaa'}}>Moovi/Voovi CMS - 3.0.0</p>
        </div>
        </>
    )
}
export default Dashboard